import { requestApi } from '../util/network'

// 获取盲盒列表
export const getBoxList =
  (parmas, stateType, orderKey, keyword, status, order_sn) =>
    requestApi(
      '/box/list',
      'POST',
      {
        'status': status,
        'page': parmas.page,
        'per_page': parmas.per_page,
        'state_type': stateType,
        'order_key': orderKey,
        'keyword': keyword,
        'order_sn': order_sn,
      },
      'member'
    )
// 获取礼品卡列表
export const getGiftList =
  (parmas, stateType, orderKey, keyword, status, order_sn) =>
    requestApi(
      '/gift/list',
      'POST',
      {
        'status': status,
        'page': parmas.page,
        'per_page': parmas.per_page,
        'state_type': stateType,
        'order_key': orderKey,
        'order_sn': order_sn,
        'keyword': keyword
      },
      'member'
    )
// 获取盲盒详情
export const getBoxInfo =
  (orderId) =>
    requestApi(
      '/box/show',
      'POST',
      {
        'id': orderId
      },
      'member'
    )
// 获取礼品卡详情
export const geGiftInfo =
  (orderId) =>
    requestApi(
      '/gift/show',
      'POST',
      {
        'id': orderId
      },
      'member'
    )
// 盲盒提货
export const addBoxOrder =
  (data) =>
    requestApi(
      '/box/add_box_order',
      'POST',
      data,
      'member'
    )
// 盲盒开盒
export const openBox =
  (orderId) =>
    requestApi(
      '/box/open_box',
      'POST',
      {
        'id': orderId
      },
      'member'
    )
// 盲盒回收
export const addBoxSave =
  (orderId) =>
    requestApi(
      '/box/add_box_save',
      'POST',
      {
        'id': orderId
      },
      'member'
    )
// 礼品卡严重绑定
export const BindGift =
  (card) =>
    requestApi(
      '/gift/band_gift',
      'POST',
      {
        'card': card
      },
      'member'
    )
// 礼品卡回收
export const GiftSave =
  (card, code) =>
    requestApi(
      '/gift/add_gift_save',
      'POST',
      {
        'card': card,
        'code': code,
      },
      'member'
    )



// 获取用户订单列表
export const getOrderList =
  (parmas, stateType, orderKey, keyword) =>
    requestApi(
      '/Memberorder/order_list',
      'POST',
      {
        'page': parmas.page,

        'per_page': parmas.per_page,
        'state_type': stateType,
        'order_key': orderKey,
        'keyword': keyword
      },
      'member'
    )
// 获取订单信息
export const getOrderInfo =
  (orderId) =>
    requestApi(
      '/Memberorder/order_info',
      'POST',
      {
        'order_id': orderId
      },
      'member'
    )
// 订单评价
export const saveOrderEvaluate =
  (orderId, result) =>
    requestApi(
      '/Memberevaluate/save',
      'POST',
      Object.assign(
        {
          'order_id': orderId
        },
        result),
      'member'
    )
// 获取评价信息
export const getOrderEvaluateInfo =
  (orderId) =>
    requestApi(
      '/Memberevaluate/index',
      'POST',
      {
        'order_id': orderId
      },
      'member'
    )
// 取消订单
export const cancelOrder =
  (orderId) =>
    requestApi(
      '/Memberorder/order_cancel',
      'POST',
      {
        'order_id': orderId
      },
      'member'
    )
// 删除订单
export const deleteOrder =
  (orderId) =>
    requestApi(
      '/Memberorder/order_delete',
      'POST',
      {
        'order_id': orderId
      },
      'member'
    )
// 订单收货
export const receiveOrder =
  (orderId) =>
    requestApi(
      '/Memberorder/order_receive',
      'POST',
      {
        'order_id': orderId
      },
      'member'
    )
// 物流跟踪
export const getOrderDeliver =
  (orderId) =>
    requestApi(
      '/Memberorder/search_deliver',
      'POST',
      {
        'order_id': orderId
      },
      'member'
    )
